function cleanEmptyCarousels(){
  const recommendationsCarousels = document.querySelectorAll('.shopify-section--recommendations .featured-collections-carousel__item[data-blockid]');
  let oneIsSelected = false;
  
  recommendationsCarousels.forEach((carousel)=>{
    if(carousel.querySelectorAll('product-card:not([hidden])').length == 0){
      carousel.classList.remove('is-selected');
      const associatedButton = document.querySelector(`button[data-blockid="${carousel.getAttribute('data-blockid')}"]`);
      if(associatedButton){
        associatedButton.setAttribute('data-hidden', 'true');
        associatedButton.setAttribute('aria-current', 'false');
      }
    }else{
      const associatedButton = document.querySelector(`[data-blockid="${carousel.getAttribute('data-blockid')}"]`);
      if (associatedButton) {
        associatedButton.removeAttribute('data-hidden');

        if (associatedButton.getAttribute('aria-current') == 'true'){
          oneIsSelected = true
        }else if(associatedButton.getAttribute('aria-current') == 'false' && !oneIsSelected){
          associatedButton.click();
          oneIsSelected = true;
        }
      }
    }
  });
}

function updateCarouselsProducts(e){
  if (e.detail.variant.id) {
    const optionSelector = document.querySelector(`.product [data-variantid*="${e.detail.variant.id}"][data-colorid]`);
    if (optionSelector) {
      document.querySelectorAll(`[data-color]`).forEach((colorCodedElement) => {
        if (colorCodedElement.getAttribute('data-color') == optionSelector.getAttribute('data-colorid')) {
          colorCodedElement.removeAttribute('hidden');
        } else {
          colorCodedElement.setAttribute('hidden', 'hidden');
        }
      });
    }
  }

  cleanEmptyCarousels();
}

document.addEventListener('DOMContentLoaded', ()=>{
  const masterForm = document.querySelector('.product-info__block-item .shopify-product-form');
  if(masterForm){
    masterForm.addEventListener('variant:change', updateCarouselsProducts)
  }
})